import { SecondaryButton } from "../SecondaryButton";
import Image from "next/image";
import Recruiter from '../../../public/assets/recruiter.webp'
import { useRouter } from 'next/router'

function RecruiterBannerDesktop()
{
  const router = useRouter();
    return (
      <div className="w-[100%] flex justify-center px-[60px] mb-[88px] customgradient-banner">
        <div className="rounded-[24px] flex sm:pl-[28px] md:pl-[56px] justify-between custom-gradient-banner">
        <div className="w-[70%] flex flex-col sm:pt-[24px] md:pt-[48px] sm:space-y-[16px] md:space-y-[32px]">
          <div className="text-greyTertiaryBase900 font-noto-sans sm:text-[20px]  md:text-[40px] font-[600] sm:leading-24 md:leading-[39px] sm:w-[90%] md:w-[60%]">
            Looking to hire? Check out our platform for recruiters.
          </div>
          <SecondaryButton title={'Post a Job'} className="h-[48px] border-[#989898] sm:w-[60%] md:w-[25%]" onClick={()=>{
                router.push(`/hire`)
            }}/>
        </div>
        <div className="rounded-[24px] h-fit w-fit">
            <Image src={Recruiter} alt="recruiter_lokal.jobs" className="rounded-r-[24px] md:w-[379px] md:h-[296px] sm:w-[279px] sm:h-[196px]"/>

        </div>

        </div>
     
      </div>
    )
}


export default RecruiterBannerDesktop;